import type { User } from '@/providers/AuthProvider/User';
import { createContext } from 'react';

interface AuthContextInterface {
  user: User | null;
  isAuthenticated: boolean;
  error: Error | null;
  isLoading: boolean;
}
const AUTH_CONTEXT_DEFAULT_VALUE = {
  user: null,
  isAuthenticated: false,
  error: null,
  isLoading: false,
};

export const AuthContext = createContext<AuthContextInterface>(
  AUTH_CONTEXT_DEFAULT_VALUE,
);
